import { getService, postService } from '../api/service.js'
// 登录
export const signPost = params => {
  return postService('/api/jfy/jfyLogin', params)
}
// 退出
export const outPost = params => {
  return postService('/api/jfy/jfyLogout', params)
}
// token刷新
export const tokenFreshPost = params => {
  return postService('/api/jfy/jfyRefresh', params)
}
/**
 * name 登出
 * time 2021-09-07
 * */
export const codeGet = params => {
  return getService('/api/auth/getCaptcha', params)
}
export const getJfyInfo = params => {
  return postService('/api/jfy/getJfyInfo', params)
}
export const  getJfyScenicWarning = params => {
  return   postService('api/jfy/getJfyScenicWarning', params)
}